exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-ButtonHide-Root {\n  display: block;\n  width: 100%;\n  background-color: #dfe4e7;\n  border-radius: 3px;\n  box-sizing: border-box;\n  padding: 15px;\n  cursor: pointer;\n  user-select: none;\n}\n.Discussion-ButtonHide-Label {\n  color: #4f5152;\n  font-size: 13px;\n  font-weight: bold;\n  line-height: 18px;\n  text-align: center;\n  text-transform: uppercase;\n}\n", ""]);

// exports
